import { addFamilyMember } from 'app/src/msw/membership/api/addFamilyMeber'
import { addFamilyMemberPrivacyDocument } from 'app/src/msw/membership/api/addFamilyMemberPrivacyDocument'
import { deleteFamilyMember } from 'app/src/msw/membership/api/deleteFamilyMember'
import { deleteFamilyMemberPrivacyDocument } from 'app/src/msw/membership/api/deleteFamilyMemberPrivacyDocument'
import { fiscalCodeValidate } from 'app/src/msw/membership/api/fiscalCodeValidate'
import { getFamilyMembers } from 'app/src/msw/membership/api/getFamilyMembers'
import { getMembershipById } from 'app/src/msw/membership/api/getMembershipById'
import { getUserInfo } from 'app/src/msw/membership/api/getUserInfo'
import { patchMembership } from 'app/src/msw/membership/api/patchMembership'
import { putFamilyMember } from 'app/src/msw/membership/api/putFamilymember'
import { signalFamilyMemberPrivacyDocumentUploaded } from 'app/src/msw/membership/api/signalFamilyMemberPrivacyDocumentUploaded'
import { uploadFamilyMemberPrivacyDocument } from 'app/src/msw/membership/api/uploadFamilyMemberPrivacyDocument'
import { userSelfRegistration } from 'app/src/msw/membership/api/userSelfRegistration'
import { userSelfRegistrationConfiguration } from 'app/src/msw/membership/api/userSelfRegistrationConfiguration'

export const membershipHandlers = [
  getMembershipById,
  addFamilyMember,
  deleteFamilyMember,
  putFamilyMember,
  getFamilyMembers,
  patchMembership,
  deleteFamilyMemberPrivacyDocument,
  userSelfRegistration,
  addFamilyMemberPrivacyDocument,
  signalFamilyMemberPrivacyDocumentUploaded,
  fiscalCodeValidate,
  getUserInfo,
  userSelfRegistrationConfiguration,
  uploadFamilyMemberPrivacyDocument,
]
